import placeholderImage from "../../assets/watch.png";
import clsx from "clsx";
import React, { MouseEventHandler, useCallback } from "react";
import Skeleton from "react-loading-skeleton";
import { useQuery } from "urql";
import { GET_CATEGORY_INFO } from "../../queries/getCategoryInfo.gql";

import { CategoryTree, StrapiCmsMenuItem } from "../../queries/graphql";
import { resolveImageUrlOnly } from "../../utils/resolveImageCDN";
import { LazyLinkToCategory } from "./lazylink";
import { Icon } from "../Icon";
import * as classes from "./desktopMenuRight.module.scss";
import { useHeaderStore } from "../../hooks/useHeaderStore";
interface IComponentProps {
  item: StrapiCmsMenuItem;
}

const MenuItem = ({ item }: IComponentProps) => {
  const categoryId = item.CategoryId;
  const [{ data, error }] = useQuery<{ category: CategoryTree }>({
    query: GET_CATEGORY_INFO,
    variables: {
      id: categoryId,
    },
  });

  const itemImage = item?.Image?.url;
  const categoryImage = data?.category?.thumbnail_image;
  const targetLink = data?.category?.url_path;
  const setShowMenu = useHeaderStore((state) => state.setModal);
  const closeModal = useCallback(() => setShowMenu("none"), []);
  if (!targetLink) {
    return (
      <a href="#" className={classes.item}>
        <div className={classes.thumbnail}>Loading...</div>
        <div className={classes.title}>
          <Skeleton width={100}></Skeleton>
        </div>
      </a>
    );
  }
  return (
    <a
      key={item.id}
      href={`/${targetLink}`}
      className={classes.item}
      onClick={closeModal}
    >
      {itemImage ? (
        <img
          className={classes.thumbnail}
          src={resolveImageUrlOnly({ src: itemImage, type: "image-cms" })}
          // loader={resolveImageCDN({ type: 'image-cms', aspectRatio: 1 })}
          alt="thumbnail"
          width={100}
          height={100}
        />
      ) : categoryImage ? (
        <img
          className={classes.thumbnail}
          src={resolveImageUrlOnly({
            src: categoryImage,
            type: "image-category",
          })}
          alt="thumbnail"
          width={100}
          height={100}
        />
      ) : (
        <img
          className={classes.thumbnail}
          src={placeholderImage.src}
          alt="thumbnail"
          width={100}
          height={100}
        />
      )}

      <div className={classes.title}>{item.Title}</div>
    </a>
  );
};
const MenuItemLink = ({
  item,
  isFullHeight,
}: IComponentProps & { isFullHeight: boolean }) => {
  const categoryId = item.CategoryId;

  const [{ data, error }] = useQuery<{ category: CategoryTree }>({
    query: GET_CATEGORY_INFO,
    variables: {
      id: categoryId,
    },
  });
  const setShowMenu = useHeaderStore((state) => state.setModal);
  const closeModal = useCallback(() => setShowMenu("none"), []);
  const targetLink = data?.category?.url_path;
  return (
    <a
      key={item.id}
      href={`/${targetLink}`}
      className={clsx(classes.item, {
        [classes.itemFullHeight]: isFullHeight,
      })}
      onClick={closeModal}
    >
      <div className={classes.textLink} style={{ background: "transparent" }}>
        <span className={classes.showAllText}>XEM TẤT CẢ</span>
        <Icon classes={{ root: classes.arrow }} name="line_right"></Icon>
      </div>
    </a>
  );
};
const DesktopMenuRightLayoutForChildren = ({
  items,
  parentItem,
}: {
  parentItem: StrapiCmsMenuItem;
  items: StrapiCmsMenuItem[];
}) => {
  const shouldVertical = items.length % 2 == 0 && items.length < 5;
  return (
    <div
      className={clsx(classes.rootWithChildren, {
        [classes.rootVertical]: shouldVertical,
      })}
    >
      {items.map((item) => {
        return <MenuItem key={item.id} item={item}></MenuItem>;
      })}
      <MenuItemLink
        key="show_all_item"
        item={parentItem}
        isFullHeight={shouldVertical}
      ></MenuItemLink>
    </div>
  );
};
const DesktopMenuRightLayoutForNoChildren = ({
  parentItem,
}: {
  parentItem: StrapiCmsMenuItem;
}) => {
  const setShowMenu = useHeaderStore((state) => state.setModal);
  const closeModal = useCallback(() => setShowMenu("none"), []);
  return (
    <div className={classes.rootWithoutChildren}>
      {parentItem?.Image?.url ? (
        <img
          src={resolveImageUrlOnly({
            type: "image-cms",
            src: parentItem?.Image?.url,
          })}
          // loader={resolveImageCDN({ type: 'image-cms', aspectRatio: 1 })}
          className={classes.thumbnail}
          width={270}
          height={270}
        ></img>
      ) : (
        <img
          className={classes.thumbnail}
          src={placeholderImage.src}
          // loader={resolveImageCDN({ type: 'image-category', aspectRatio: 1 })}
          alt="thumbnail"
          width={270}
          height={270}
        />
      )}

      <div className={classes.content}>
        <div>
          <div className={classes.subtitle}>{parentItem.Subtitle}</div>
          <div className={classes.description}>{parentItem.Description}</div>
        </div>
        <div>
          <LazyLinkToCategory
            title={parentItem.ButtonTitle}
            classes={{ root: classes.ctaButton }}
            id={parentItem.CategoryId}
          >
            <a className={classes.ctaButton} onClick={closeModal}>
              {parentItem.ButtonTitle}
            </a>
          </LazyLinkToCategory>
        </div>
      </div>
    </div>
  );
};

export const DesktopMenuRight = (props: IComponentProps) => {
  const { item } = props;
  const activeItemNonDirectChildren = item.menu_children
    .filter((el) => el.Visible)
    .filter((el) => !el.ShowUnderParent)
    .sort((a, b) => a.RelativePosition - b.RelativePosition);

  return activeItemNonDirectChildren.length > 0 ? (
    <DesktopMenuRightLayoutForChildren
      parentItem={item}
      items={activeItemNonDirectChildren}
    ></DesktopMenuRightLayoutForChildren>
  ) : (
    <DesktopMenuRightLayoutForNoChildren
      parentItem={item}
    ></DesktopMenuRightLayoutForNoChildren>
  );
};
